import { render } from "./SelectAutocompleteLabel.vue?vue&type=template&id=705a2da0&scoped=true"
import script from "./SelectAutocompleteLabel.vue?vue&type=script&lang=ts"
export * from "./SelectAutocompleteLabel.vue?vue&type=script&lang=ts"

import "./SelectAutocompleteLabel.vue?vue&type=style&index=0&id=705a2da0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-705a2da0"

export default script